module.exports = __webpack_public_path__ + "static/branch-photo-bc8c6425f09ad7e4862d9fec24e948f6.png";